<template>
  <div :class="`searchbar-wrapper ${className}`">
    <!-- <el-radio-group v-model="listMode" class="change-modal" size="mini" @change="tableModel" v-if="!companyShowSearch">
      <el-radio-button label="table"><i class="el-icon-s-grid"></i></el-radio-button>
      <el-radio-button label="list"><i class="el-icon-notebook-2"></i></el-radio-button>
    </el-radio-group> -->
    <el-button v-if="!companyShowSearch" class="change-modal" size="mini" type="primary" plain @click="tableModel"
      >阶段模式</el-button
    >
    <div v-if="!companyShowSearch">
      <BaseSearchBarItem
        v-for="(item, index) in items"
        v-if="staticItems.includes(item.label) || collapse"
        :key="index"
        :item="item"
        :items="items"
      />
    </div>
    <div v-else>
      <BaseSearchBarItem
        v-for="(item, index) in companyItems"
        v-if="staticItems.includes(item.label) || collapse"
        :key="index"
        :item="item"
        :items="items"
      />
      <div class="search-handler flex-row" style="display:inline-flex;margin-left:10px">
        <div class="mr10">
          <el-button :loading="loading" type="primary" size="mini" @click="search">搜索</el-button>
        </div>
        <div class="mr10"><el-button :loading="loading" type="primary" size="mini" @click="clear">清空</el-button></div>
      </div>
    </div>
    <div v-if="!companyShowSearch" class="search-handler flex-row">
      <div class="mr10"><el-button :loading="loading" type="primary" size="mini" @click="search">搜索</el-button></div>
      <div v-if="!companyShowSearch" class="mr10">
        <el-button :loading="loading" type="primary" size="mini" @click="clear">清空</el-button>
      </div>
      <el-button v-if="!companyShowSearch" type="text" @click="handleCollapse">
        {{ collapse ? '收起' : '更多搜索项' }} <i :class="collapse ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </el-button>
    </div>
  </div>
</template>

<script>
import BaseSearchBarItem from './BaseSearchBarItem.vue'
import { locations } from '../constant/type'

export default {
  components: { BaseSearchBarItem },
  props: {
    onSearch: { type: Function, default: () => {} },
    onCollapse: { type: Function, default: () => {} },
    className: { type: String, default: '' },
    companyShowSearch: { type: Boolean, default: false },
    companyName: { type: String, default: undefined },
  },
  data() {
    return {
      listMode: 'list',
      items: [
        {
          label: '公司',
          key: '客户公司',
          val: undefined,
        },
        {
          label: '项目名称',
          val: undefined,
        },
        {
          label: '状态',
          key: '项目状态',
          options: ['进展中', '已暂停', '已成功', '已结束'],
          val: undefined,
        },
        {
          label: '职能模块',
          multiple: true,
          val: undefined,
          options: [],
        },
        {
          label: '细分职能',
          multiple: true,
          options: [],
          val: undefined,
        },
        {
          label: '职级',
          multiple: true,
          options: [
            { label: '1、高管', value: 1 },
            { label: '2、部门总', value: 2 },
            { label: '3、部门副总-总助-团队长', value: 3 },
            { label: '4、部门核心骨干', value: 4 },
            { label: '5、新人（三年以下）', value: 5 },
          ],
          val: undefined,
        },
        {
          label: '参与项目',
          multiple: true,
          remote: 'users',
          val: undefined,
          options: [],
        },
        {
          label: '客户开发',
          multiple: true,
          remote: 'users',
          val: undefined,
          options: [],
        },
        {
          label: '项目对接',
          multiple: true,
          remote: 'users',
          val: undefined,
          options: [],
        },
        {
          label: '项目经理',
          multiple: true,
          remote: 'users',
          val: undefined,
          options: [],
        },
        {
          label: '项目成员',
          multiple: true,
          remote: 'users',
          val: undefined,
          options: [],
        },
        {
          label: '创建时间',
          key: 'createdAt',
          type: 'daterange',
          val: undefined,
        },
        {
          label: '平台',
          multiple: true,
          options: ['A', 'B', 'C'],
          val: undefined,
        },
        {
          label: '业绩',
          multiple: true,
          options: ['aaa', 'aa', 'a', 'b', 'c', 'd'],
          val: undefined,
        },
        {
          label: '擅长方向',
          multiple: true,
          options: [],
          val: undefined,
        },
        {
          label: '个性标签',
          key: 'tags',
          placeholder: '关键词用空格键隔开',
          val: undefined,
        },
        {
          label: '地域',
          multiple: true,
          options: locations,
          val: undefined,
        },
        {
          label: '目标行业',
          multiple: true,
          options: app.industries || [],
          val: undefined,
        },
        {
          label: '项目编号',
          key: '编号',
          val: undefined,
        },
        {
          label: '全文检索',
          val: undefined,
        },
      ],
      companyItems: [
        {
          label: '状态',
          key: '项目状态',
          options: ['进展中', '已暂停', '已成功', '已结束'],
          val: undefined,
        },
        {
          label: '职能模块',
          multiple: true,
          val: undefined,
          options: [],
        },
        {
          label: '全文检索',
          val: undefined,
        },
      ],
      staticItems: [
        '全文检索',
        '项目名称',
        '职能模块',
        '公司',
        '参与项目',
        '状态',
        // '平台',
        // '细分职能',
        '职级',
        // '业绩',
        // '擅长方向',
        '地域',
        '目标行业',
        '项目编号',
      ],
      loading: false,
      collapse: false,
      initUserOptions: false,
      initCategoryOptions: false,
    }
  },
  methods: {
    tableModel() {
      this.$router.push('/projects')
    },
    clear() {
      const items = this.companyShowSearch && this.companyName ? this.companyItems : this.items
      items.map(item => {
        if (Array.isArray(item.val)) {
          item.val = []
        } else {
          item.val = ''
        }
      })
      if (this.companyShowSearch && this.companyName) this.onSearch({ 客户公司: this.companyName })
      else this.onSearch()
    },
    search() {
      const query = this.companyShowSearch && this.companyName ? { 客户公司: this.companyName } : {}
      const items = this.companyShowSearch && this.companyName ? this.companyItems : this.items
      items.map(item => {
        if (item.key === 'tags') {
          if (!item.val) return
          const text = item.val.trim()
          if (!text) return
          const searchTags = text.trim().split(' ')
          query.tags = searchTags
        } else {
          item.val && item.val.length > 0 && (query[item.key || item.label] = item.val)
        }
      })
      this.onSearch(query)
    },
    handleCollapse() {
      this.collapse = !this.collapse
      this.onCollapse && this.onCollapse(this.collapse)
    },
  },
}
</script>

<style scoped>
.searchbar-wrapper {
  margin: 0 0 5px 0;
  padding: 0 30px 0 20px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  position: relative;
}
.change-modal {
  position: absolute;
  top: 6px;
  right: 6px;
}
</style>
